/**
 * Лососёвые — 26 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ЛОСОСЁВЫЕ = [
    // ── Наши воды ──
    {
        id: 'brown_trout',
        семейство: 'лососёвые',
        latin: 'Salmo trutta fario',
        повадка: 'холодолюбивый',
        minKg: 0.1,
        maxKg: 4,
        typicalKg: 0.5,
        typicalLengthM: 0.32,
        depthM: 1.2,
        depthBandM: 1.2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 12, макс: 19 },
        течение: 'сильное',
        держится: ['камни', 'коряги', 'перекат'],
        стая: 'одиночка',
        нерест: { с: 10, по: 12 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'икра', вес: 0.2 },
        ],
    },
    {
        id: 'lake_trout',
        семейство: 'лососёвые',
        latin: 'Salmo trutta lacustris',
        повадка: 'холодолюбивый',
        minKg: 0.5,
        maxKg: 12,
        typicalKg: 2,
        typicalLengthM: 0.5,
        depthM: 6,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 11, макс: 18 },
        течение: 'стоячая',
        держится: ['бровка', 'открытая_вода', 'камни'],
        стая: 'одиночка',
        нерест: { с: 10, по: 12 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
    },
    {
        id: 'rainbow_trout',
        семейство: 'лососёвые',
        latin: 'Oncorhynchus mykiss',
        повадка: 'холодолюбивый',
        minKg: 0.2,
        maxKg: 8,
        typicalKg: 1,
        typicalLengthM: 0.38,
        depthM: 2,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 2, опт: 14, макс: 21 },
        течение: 'любое',
        держится: ['открытая_вода', 'камни', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 3, по: 5 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'wobbler', вес: 0.4 },
        ],
    },
    {
        id: 'sea_trout',
        семейство: 'лососёвые',
        latin: 'Salmo trutta trutta',
        повадка: 'угонщик',
        minKg: 0.5,
        maxKg: 14,
        typicalKg: 2.5,
        typicalLengthM: 0.55,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 2, опт: 12, макс: 18 },
        течение: 'слабое',
        держится: ['яма', 'бровка', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 10, по: 12 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'живец', вес: 0.2 },
        ],
    },
    {
        id: 'salmon',
        семейство: 'лососёвые',
        latin: 'Salmo salar',
        повадка: 'угонщик',
        minKg: 1.5,
        maxKg: 30,
        typicalKg: 5,
        typicalLengthM: 0.75,
        depthM: 3,
        depthBandM: 2.5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 10, макс: 18 },
        течение: 'сильное',
        держится: ['яма', 'перекат', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 9, по: 11 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'икра', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    {
        id: 'arctic_char',
        семейство: 'лососёвые',
        latin: 'Salvelinus alpinus',
        повадка: 'холодолюбивый',
        minKg: 0.3,
        maxKg: 9,
        typicalKg: 1.2,
        typicalLengthM: 0.42,
        depthM: 8,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'круглосуточная',
        вода: { мин: 0, опт: 8, макс: 14 },
        течение: 'стоячая',
        держится: ['бровка', 'открытая_вода', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 9, по: 11 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'икра', вес: 0.6 },
            { чем: 'резка', вес: 0.4 },
            { чем: 'wobbler', вес: 0.4 },
        ],
    },
    {
        id: 'palia',
        семейство: 'лососёвые',
        latin: 'Salvelinus lepechini',
        повадка: 'холодолюбивый',
        minKg: 0.5,
        maxKg: 7,
        typicalKg: 1.5,
        typicalLengthM: 0.45,
        depthM: 12,
        depthBandM: 5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'круглосуточная',
        вода: { мин: 1, опт: 8, макс: 13 },
        течение: 'стоячая',
        держится: ['камни', 'бровка', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 9, по: 10 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'червь', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'taimen',
        семейство: 'лососёвые',
        latin: 'Hucho taimen',
        повадка: 'засадный',
        minKg: 2,
        maxKg: 40,
        typicalKg: 6,
        typicalLengthM: 0.85,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'очень_редкая',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 10, макс: 16 },
        течение: 'сильное',
        держится: ['яма', 'перекат', 'коряги'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'лягушка', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'danube_salmon',
        семейство: 'лососёвые',
        latin: 'Hucho hucho',
        повадка: 'засадный',
        minKg: 1.5,
        maxKg: 25,
        typicalKg: 4,
        typicalLengthM: 0.7,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'очень_редкая',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 10, макс: 16 },
        течение: 'сильное',
        держится: ['яма', 'коряги', 'перекат'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 3, по: 5 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'резка', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'marble_trout',
        семейство: 'лососёвые',
        latin: 'Salmo marmoratus',
        повадка: 'холодолюбивый',
        minKg: 0.5,
        maxKg: 20,
        typicalKg: 2.5,
        typicalLengthM: 0.55,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 3, опт: 11, макс: 18 },
        течение: 'сильное',
        держится: ['яма', 'камни', 'коряги'],
        стая: 'одиночка',
        нерест: { с: 11, по: 12 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'живец', вес: 0.4 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'lenok',
        семейство: 'лососёвые',
        latin: 'Brachymystax lenok',
        повадка: 'холодолюбивый',
        minKg: 0.3,
        maxKg: 6,
        typicalKg: 1,
        typicalLengthM: 0.4,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 10, макс: 17 },
        течение: 'сильное',
        держится: ['яма', 'камни', 'перекат'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'spoon', вес: 0.4 },
        ],
    },
    // ── Наши воды ──
    {
        id: 'sevan_trout',
        семейство: 'лососёвые',
        latin: 'Salmo ischchan',
        повадка: 'холодолюбивый',
        minKg: 0.3,
        maxKg: 15,
        typicalKg: 1.5,
        typicalLengthM: 0.45,
        depthM: 10,
        depthBandM: 5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'единичная',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 10, макс: 16 },
        течение: 'стоячая',
        держится: ['бровка', 'камни', 'открытая_вода'],
        стая: 'малая_стая',
        нерест: { с: 11, по: 1 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'живец', вес: 0.4 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'рачок', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    // ── Балканы, Дунай и Междуречье ──
    {
        id: 'softmouth_trout',
        семейство: 'лососёвые',
        latin: 'Salmo obtusirostris',
        повадка: 'холодолюбивый',
        minKg: 0.2,
        maxKg: 3,
        typicalKg: 0.7,
        typicalLengthM: 0.4,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'плёночная',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 4, опт: 13, макс: 19 },
        течение: 'слабое',
        держится: ['трава', 'камни', 'поверхность'],
        стая: 'малая_стая',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'мушка', вес: 1 },
            { чем: 'ручейник', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'wobbler', вес: 0.4 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'опарыш', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    {
        id: 'dentex_trout',
        семейство: 'лососёвые',
        latin: 'Salmo dentex',
        повадка: 'угонщик',
        minKg: 0.4,
        maxKg: 8,
        typicalKg: 1.5,
        typicalLengthM: 0.55,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 4, опт: 12, макс: 19 },
        течение: 'сильное',
        держится: ['камни', 'яма', 'открытая_вода'],
        стая: 'одиночка',
        нерест: { с: 10, по: 12 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
    },
    {
        id: 'ohrid_trout',
        семейство: 'лососёвые',
        latin: 'Salmo letnica',
        повадка: 'холодолюбивый',
        minKg: 0.3,
        maxKg: 9,
        typicalKg: 1.2,
        typicalLengthM: 0.5,
        depthM: 6,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 3, опт: 11, макс: 18 },
        течение: 'стоячая',
        держится: ['бровка', 'открытая_вода', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 12, по: 2 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'рачок', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    // ── Западная и Северная Европа ──
    {
        id: 'alpine_char',
        семейство: 'лососёвые',
        latin: 'Salvelinus umbla',
        повадка: 'холодолюбивый',
        minKg: 0.3,
        maxKg: 6,
        typicalKg: 1.2,
        typicalLengthM: 0.45,
        depthM: 20,
        depthBandM: 12,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 8, макс: 14 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'бровка', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 11, по: 12 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    // ── Тихоокеанские лососи ──
    // Ловятся в реках Камчатки, Сахалина и Приморья — это речная рыбалка, хоть рыба и проходная.
    {
        id: 'chinook',
        семейство: 'лососёвые',
        latin: 'Oncorhynchus tshawytscha',
        повадка: 'угонщик',
        minKg: 3,
        maxKg: 25,
        typicalKg: 8,
        typicalLengthM: 0.9,
        depthM: 4,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 11, макс: 17 },
        течение: 'сильное',
        держится: ['яма', 'бровка', 'перекат'],
        стая: 'малая_стая',
        нерест: { с: 7, по: 8 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'икра', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'резка', вес: 0.2 },
        ],
    },
    {
        id: 'coho',
        семейство: 'лососёвые',
        latin: 'Oncorhynchus kisutch',
        повадка: 'угонщик',
        minKg: 1.5,
        maxKg: 8,
        typicalKg: 3,
        typicalLengthM: 0.65,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 2, опт: 11, макс: 17 },
        течение: 'слабое',
        держится: ['яма', 'коряги', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 9, по: 12 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'икра', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'резка', вес: 0.2 },
        ],
    },
    {
        id: 'chum',
        семейство: 'лососёвые',
        latin: 'Oncorhynchus keta',
        повадка: 'угонщик',
        minKg: 1.5,
        maxKg: 8,
        typicalKg: 3.5,
        typicalLengthM: 0.7,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 10, макс: 16 },
        течение: 'сильное',
        держится: ['яма', 'перекат', 'твёрдое_дно'],
        стая: 'большая_стая',
        нерест: { с: 9, по: 11 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'икра', вес: 0.4 },
        ],
    },
    {
        id: 'pink_salmon',
        семейство: 'лососёвые',
        latin: 'Oncorhynchus gorbuscha',
        повадка: 'угонщик',
        minKg: 0.8,
        maxKg: 3.5,
        typicalKg: 1.6,
        typicalLengthM: 0.5,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 2, опт: 11, макс: 17 },
        течение: 'сильное',
        держится: ['перекат', 'твёрдое_дно', 'камни'],
        стая: 'большая_стая',
        нерест: { с: 8, по: 9 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'икра', вес: 0.2 },
        ],
    },
    {
        id: 'masu',
        семейство: 'лососёвые',
        latin: 'Oncorhynchus masou',
        повадка: 'угонщик',
        minKg: 0.6,
        maxKg: 4,
        typicalKg: 1.5,
        typicalLengthM: 0.55,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 11, макс: 17 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 8, по: 9 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'икра', вес: 0.4 },
            { чем: 'ручейник', вес: 0.2 },
        ],
    },
    {
        id: 'sakhalin_taimen',
        семейство: 'лососёвые',
        latin: 'Parahucho perryi',
        повадка: 'засадный',
        minKg: 2,
        maxKg: 25,
        typicalKg: 6,
        typicalLengthM: 0.9,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'очень_редкая',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 9, макс: 16 },
        течение: 'слабое',
        держится: ['яма', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'живец', вес: 0.4 },
            { чем: 'резка', вес: 0.4 },
            { чем: 'мушка', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    // ── Восточная Азия ──
    {
        id: 'iwana',
        семейство: 'лососёвые',
        latin: 'Salvelinus leucomaenis',
        повадка: 'холодолюбивый',
        minKg: 0.08,
        maxKg: 1.5,
        typicalKg: 0.3,
        typicalLengthM: 0.32,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 10, макс: 16 },
        течение: 'слабое',
        держится: ['коряги', 'камни', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 9, по: 11 },
        чем: [
            { чем: 'ручейник', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'икра', вес: 0.2 },
        ],
    },
    {
        id: 'yamame',
        семейство: 'лососёвые',
        latin: 'Oncorhynchus masou masou',
        повадка: 'холодолюбивый',
        minKg: 0.05,
        maxKg: 1.5,
        typicalKg: 0.2,
        typicalLengthM: 0.28,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 2, опт: 12, макс: 18 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'коряги'],
        стая: 'малая_стая',
        нерест: { с: 9, по: 10 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'ручейник', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    // ── Северная Америка ──
    {
        id: 'american_lake_trout',
        семейство: 'лососёвые',
        latin: 'Salvelinus namaycush',
        повадка: 'холодолюбивый',
        minKg: 1,
        maxKg: 15,
        typicalKg: 3,
        typicalLengthM: 0.7,
        depthM: 25,
        depthBandM: 15,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'круглосуточная',
        вода: { мин: 1, опт: 9, макс: 15 },
        течение: 'стоячая',
        держится: ['яма', 'бровка', 'камни'],
        стая: 'одиночка',
        нерест: { с: 10, по: 11 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
        ],
    },
    {
        id: 'brook_char',
        семейство: 'лососёвые',
        latin: 'Salvelinus fontinalis',
        повадка: 'холодолюбивый',
        minKg: 0.1,
        maxKg: 2.5,
        typicalKg: 0.4,
        typicalLengthM: 0.33,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 12, макс: 19 },
        течение: 'слабое',
        держится: ['коряги', 'камни', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 10, по: 11 },
        чем: [
            { чем: 'spinner', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'икра', вес: 0.2 },
        ],
    },
];
//# sourceMappingURL=salmonids.js.map